export const styles = {
  containerBox: {
    margin: 1,
    backgroundColor: "white",
   
    minHeight: {
      xs: "auto",
      sm: "80vh",
    },
    my: "1.2%",
    borderRadius: "5px",
  },
  titleBox: {
    marginTop: "8px",
    px: 3,
    fontSize: "18px",
    fontWeight: "500",
    lineHeight: "24px ",
    marginBottom: "6px",
  },
  contentBox: {
    // p: 1,
    width: "100%",
  },
  modelSaveButtonBox: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "25px",
  },
  borderBox: {
    border: "1px solid #c4c4c4",
    borderRadius: "5px",
    padding: "15px",
    px: { xs: 2, sm: 7 },
    marginTop: "18px",
  },
  sectionHeader: {
    display: "flex",
    gap: 2,
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    width: "100%",
  },
  sectionMainHeading: {
    fontWeight: "500",
    fontSize: { xs: "16px", sm: "16px" },
    lineHeight: "24px",
  },
  sectionMain: {
    width: "100%",
    textAlign: "left",
    justifyContent: "center",
    p: 2,
    px: { xs: 1, sm: 3 },
  },
  noPolicyContainerInner: {
    fontSize: "14px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginLeft: "37px",
    marginRight: "37px",
    gap: 2,
  },
  noPolicyContainer: {
    border: "1px solid #c4c4c4",
    borderRadius: "5px",
    padding: "15px",
    marginTop: "18px",
  },
  iconsContainer: {
    display: "flex",
    gap: 2,
    alignItems: "center",
    paddingRight: "0px",
    minWidth: "60px",
    padding: "4px",
    // Ensures icons don’t overlap the text
    justifyContent: "flex-start", // Keep icons on the right side,
  },
  policyMainDivPara: {
    fontSize: "14px",
    fontWeight: "500",
    padding: "0px",
    paddingLeft: "15px",
    margin: "0",
    // Remove default margin from the <p> tag
    height: "auto",
    textAlign: "left",
    marginRight: "15px",
    // overflowY: "auto",
    // Ensures scrolling works on the <p> tag as well,
  },
  policymainDivInner: {
    flex: 1,
    overflow: "hidden",
    wordBreak: "break-word",
    // Force text to break and wrap
    whiteSpace: "normal",
    // Ensure normal wrapping behavior
    maxHeight: "150px",
    // Ensure that the max height is applied to the text box as well
    overflowY: "auto", // Enables scrolling when content overflows,
  },
  policyMainDiv: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    width: "100%",
    marginTop: "10px",
    borderRadius: "20px",
    backgroundColor: "#EFF0F1",
    minHeight: "43px",
    padding: "10px 15px",
    // padding to make the content visually pleasant
    alignItems: "center",
    // Ensures vertical alignment for the text and icons
    maxHeight: "150px",
    // Set a max height for the container to limit the height
    //overflowY: "auto"  // Enables vertical scrolling when content exceeds maxHeight,
  },
  policyText: {
    fontSize: "14px",
    fontWeight: "500",
    padding: "0px",
    paddingLeft: "15px",
    margin: "0",
    height: "auto",
    textAlign: "left",
    marginRight: "15px",
  },
  instructionIcons: {
    display: "flex",
    gap: 2,
    alignItems: "center",
    paddingRight: "15px",
    minWidth: "60px",
    // Ensures icons don’t overlap the text
    justifyContent: "flex-end", // Keep icons on the right side,
  },
  instructionPara: {
    fontSize: "14px",
    fontWeight: "500",
    padding: "0px",
    paddingLeft: "15px",
    margin: "0",
    // Remove default margin from the <p> tag
    height: "auto",
    textAlign: "left",
    marginRight: "15px",
  },
  instructionTextContainer: {
    flex: 1,
    overflow: "hidden",
    wordBreak: "break-word",
    // Force text to break and wrap
    whiteSpace: "normal", // Ensure normal wrapping behavior,
  },
  instructionMainBox: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    width: "100%",
    marginTop: "10px",
    marginBottom: "15px",
    borderRadius: "20px",
    backgroundColor: "#EFF0F1",
    minHeight: "43px",
    padding: "10px 15px",
    // padding to make the content visually pleasant

    alignItems: "center", // Ensures vertical alignment for the text and icons,
  },
  subheading: {
    fontWeight: "500",
    fontSize: "18px",
    lineHeight: "27px",
    p: 2,
  },
};
